import { Component, inject, Input } from '@angular/core';
import { Toast, ToastService } from '../../../app/services/toast.service';

@Component({
  selector: 'app-custom-toast-item',
  standalone: true,
  imports: [],
  templateUrl: './custom-toast-item.component.html',
  styleUrl: './custom-toast-item.component.scss'
})
export class CustomToastItemComponent {

  // TODO: AGREGAR ANIMACION DE CIERRE

  private _toastService = inject(ToastService);
  @Input() toast: Toast | null = null;

  get safeToast(): Toast {
    return {
      id: '',
      color: this.toast?.color ?? 'info',
      message: this.toast?.message ?? '',
      header: this.toast?.header ?? '',
      autohide: this.toast?.autohide ?? true,
      delay: this.toast?.delay ?? 3000,
      ...this.toast
    };
  }

  ngAfterViewInit() {
    if (this.safeToast.autohide !== false) {
      this.autoDestroy();
    }
  }

  onClose(id: Toast['id']) {
    this._toastService.remove(id);
  }

  autoDestroy() {
    setTimeout(() => {
      this._toastService.remove(this.safeToast.id);
    }, this.safeToast.delay);
  }
}
